import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import { PageHero } from "../components/Sections";
import { legalContent } from "../mock/data";
import { Info } from "lucide-react";

export default function LegalPage() {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\//, "");
  const content = legalContent[slug];
  if (!content) return <Navigate to="/" replace />;

  return (
    <div>
      <PageHero title={content.title} crumbs={[{ label: content.title }]} />
      <section className="section-pad">
        <div className="container-page max-w-3xl">
          <div className="flex items-start gap-3 rounded-xl border border-primary/20 bg-secondary/50 p-4 mb-10">
            <Info className="h-5 w-5 shrink-0 text-primary" />
            <p className="text-sm text-muted-foreground">{content.updated}</p>
          </div>
          <div className="space-y-8">
            {content.sections.map((s, i) => (
              <div key={i}>
                <h2 className="font-heading text-xl font-semibold text-foreground">{i + 1}. {s.h}</h2>
                <p className="mt-2 leading-relaxed text-muted-foreground">{s.p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
